import { useStaticQuery, graphql } from "gatsby"

export const useGetTokens = () => {
  const { settingsYaml } = useStaticQuery(
    graphql`
      query GetTokens {
        settingsYaml {
          id
          CompanyAddress {
            city
            state
            street
            zipcode
          }
          CompanyEmail
          CompanyName
          CompanyPhone
          CompanySlogan
          SocialCard
          SiteURL
          FocusArea {
            one
            two
            three
          }
          SocialMediaLinks {
            facebook
            instagram
            twitter
            linkedin
            youtube
          }
        }
      }
    `
  )
  return settingsYaml
}
